import { z } from 'zod/v3';
import { ok } from 'neverthrow';
import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
  ActionTrackMetadata,
} from '@cotera/client/v0/actions/framework';
import { AgentModel } from './agent.model';
import type { ActionTrackingContext } from '../actions/framework/action-tracking';
import { v4 } from 'uuid';

type Params = {};

export class ClearChatAction extends BaseAction<
  Params,
  { t: string; message?: string }[]
> {
  title = 'Schedule Agent';
  description = 'Set the execution schedule for an agent';
  inputSchema = z.object({});
  discrete = true;

  applicable(context: ApplicableContext): boolean {
    return context.hasTargetedModelOfType(AgentModel);
  }

  async execute(
    _: Params,
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string; message?: string }[]>> {
    const agent = context.targetedModelOfType(AgentModel);

    if (agent === null) {
      return ok({});
    }

    agent.chatId.set(v4());

    return ok({});
  }

  track({
    payload: _,
    context,
  }: ActionTrackingContext<
    Params,
    { t: string; message?: string }[]
  >): ActionTrackMetadata | null {
    const agent = context.targetedModelOfType(AgentModel);
    if (agent === null) {
      return null;
    }

    return {
      event: 'agent_chat_cleared',
      properties: {
        agentId: agent.id,
        agentName: agent.name.snapshot(),
        isNew: agent.isNew,
      },
    };
  }
}
